import imgDawnLim from "@assets/events-awards/dta/img-dawn-lim.jpg";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Ms Dawn Lim Section on DTA Judges Page
 */
const DawnLimSection = (): React.ReactElement => {
  return (
    <AccordionV2
      testId="dawn-lim-section-component"
      className="border border-t-0 border-gray-175 bg-gray-150 py-4"
      headerChildren={
        <EventsAwardsAccordionHeader
          title="Ms Dawn Lim"
          className="tracking-normal"
        />
      }
      arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
      isArrowRight
    >
      <div className="mt-4 flex flex-col border-t border-gray-175 px-6 pt-4 md:flex-row">
        <div className="mb-6 h-auto w-8/12 pr-4 md:mb-2 md:w-2/12 md:pr-5">
          <img
            src={imgDawnLim}
            width={576}
            height={283}
            alt="ms-dawn-lim"
            className="object-contain"
          />
        </div>

        <div className="md:w-8/12 md:pl-1 md:pr-1">
          <p className="mb-0 font-bold">Ms Dawn Lim</p>

          <p className="font-bold">
            Executive Director Design Singapore Council
          </p>

          <p>
            As Executive Director of DesignSingapore Council (Dsg), Dawn sets
            the vision and strategy for Singapore’s national agency for design.
          </p>

          <p>
            Since taking over the reins in 2022, she has positioned Singapore
            Design for the future –focusing on design&apos;s role in shaping
            emerging technology, sustainability and systems of care. She also
            oversaw the relaunch of Singapore Design Week held every September
            and the debut of Dsg’s global showcase, Future Impact, at Milan
            Design Week 2023 and again in 2024. She is also the Co-Commissioner
            of the Singapore Pavilion at the Venice Biennale Architecture and
            leads Singapore’s highest design accolade – the President&apos;s
            Design Award.
          </p>

          <p>
            She has two decades of experience in public and private sector trade
            agreements, policymaking, partnership development and industrial
            strategy in Asia and Europe. She honed her business and commercial
            acumen in the shipping industry at PSA Corporation, and put that to
            good use subsequently at the Singapore Economic Development Board
            attracting the world’s top companies to invest in the country to
            drive economic growth.
          </p>

          <p>
            She holds a Bachelor of Science in International Relations from
            Georgetown University and a Master of Science from the Stanford
            Graduate School of Business. Dawn has presented on the power of
            design across international platforms such as the UNESCO Creative
            Cities Network, SXSW, ChangeNow Summit, Intercorp Festival of
            Innovation, Singapore Design Week, as well as with partners like
            JLL, Stagwell, Deloitte Centre for the Edge, WGSN. She is a UK
            Design Ambassador, advisory member to the Seoul Design Award and has
            been invited as a jury member on a wide range of design platforms
            including the James Dyson Award.
          </p>
        </div>
      </div>
    </AccordionV2>
  );
};
export default DawnLimSection;
